console.log('%cYou like our work? Contact us: https://undefined.de/',
  (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ?
    'font-size: 16px; background: transparent; color: #7BDEB7; padding: 8px' : 'font-size: 16px; background: transparent; color: #00000; padding: 8px');